import React, { useState, useRef, useLayoutEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const ExpandableText = ({ text, title = "Details", className = "", clamp = "line-clamp-1", testid }) => {
  const [open, setOpen] = useState(false);
  const [overflowing, setOverflowing] = useState(false);
  const ref = useRef(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const check = () => setOverflowing(el.scrollHeight > el.clientHeight + 1);
    check();
    const ro = new ResizeObserver(check);
    ro.observe(el);
    return () => ro.disconnect();
  }, [text, clamp]);

  if (!text) return null;
  return (
    <>
      <div ref={ref} className={`${clamp} break-words ${className}`} data-testid={testid}>{text}</div>
      {overflowing && (
        <button
          type="button"
          onClick={() => setOpen(true)}
          className="mt-0.5 block text-xs font-medium text-muted-foreground underline underline-offset-2 decoration-border hover:text-foreground transition-colors"
          data-testid={testid ? `${testid}-more` : undefined}
        >
          Read more
        </button>
      )}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg">
          <DialogHeader><DialogTitle>{title}</DialogTitle></DialogHeader>
          <div className="text-sm leading-relaxed whitespace-pre-wrap break-words max-h-[60vh] overflow-y-auto pr-1">{text}</div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ExpandableText;
